export default "__VITE_ASSET__CxOf4iP2__"